import { Flex } from 'antd';
import styled from 'styled-components';

export const TabsContainer = styled(Flex)`
    width: fit-content;
`;

interface IBottomContainerTrigger {
	isSelected: boolean;
}

export const Tab = styled.div<IBottomContainerTrigger>`
margin-right: -5px;
    box-shadow: ${(p) => (p.isSelected ? '0px 0px 2px 0px #fafafa' : 'none')};
    width: 40px;
    height: 20px;
    background-color: ${(p) => (p.isSelected ? '#1b4c7a' : '#001529')};
    z-index: ${(p) => (p.isSelected ? 2 : 1)};
    top: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    cursor: pointer;
    border-radius: 5px 5px 0px 0px;

    gap: 10px;

    svg {
        color: white;
        font-size: 12px;
    }

    @media (max-width: 768px) {
        svg {
            z-index: 2;
        }
    }
`;
